import type { FC } from 'react';
import { useBreakpointValue } from '@chakra-ui/react';
import { Copyright } from './copyright';
import {
    FooterDesktop,
    FooterMobile,
    FooterTabletLarge,
    FooterTabletSmall,
} from './responsive-layout';

export const Footer: FC = () => (
    <footer className="relative isolate flex flex-col border-t border-t-slt-black-200 px-4 py-8 print:hidden sm:p-8 lg:px-16 lg:py-8">
        {useBreakpointValue(
            {
                base: <FooterMobile />,
                lg: <FooterDesktop />,
                md: <FooterTabletLarge />,
                sm: <FooterTabletSmall />,
                xs: <FooterMobile />,
            },
            { fallback: 'xs' },
        )}
        <Copyright />
    </footer>
);
